import {
  Component,
  Input,
  forwardRef
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import { InputBaseComponent } from '../base/base.component';

@Component({
  selector: 'jb-input-textarea',
  templateUrl: './textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputTextareaComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputTextareaComponent),
      multi: true
    }
  ]
})
export class InputTextareaComponent extends InputBaseComponent {
  protected type: string = 'textarea';
  
  @Input()
  maxlength: string | number;
}


// WEBPACK FOOTER //
// ./src/app/form/input/textarea/textarea.component.ts